module.exports = __webpack_public_path__ + "img/video-pic3.f2042d88.jpg";